module.exports = __webpack_public_path__ + "static/media/16_plantilla_rec_combo_simple_cp_aguas_pet_591_sw.81abeb2b.png";